import React from "react";

import { Box, Typography } from "@mui/material";

// Shared page header: title + subtitle on the left, optional action buttons on the right.
// Matches the header pattern used across Employees, Tickets, etc.
function PageHeader({ title, subtitle, actions }) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={1.5}
      mb={3}
    >
      <Box>
        <Typography variant="h4" fontWeight={600} color="text.primary">
          {title}
        </Typography>

        {subtitle && (
          <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {actions && (
        <Box display="flex" alignItems="center" gap={1.2}>
          {actions}
        </Box>
      )}
    </Box>
  );
}

export default PageHeader;
